<template>
    <div id="app">
        <keep-alive :include="keppAlive">
            <router-view v-if="isRouterAlive" v-wechat-title="$route.meta.title" />
        </keep-alive>    
    </div>
</template>

<script>
export default {
    name: 'App',
    provide() {
        return {
            reload: this.reload,
        };
    },
    data() {
        return {
            isRouterAlive: true
        };
    },
    methods: {
        reload() {
            this.isRouterAlive = false;
            this.$nextTick(function() {
                this.isRouterAlive = true;
            });
        }
    },
    computed: {
        keppAlive() {
            return [''];
        }
    },
    components: {}
};
</script>
